<template>
    <main class="SectionParenthesis-MAIN DISPLAY">
        <HeaderBand @search-bar-events="(term) => searchBarEvents(term)"/>

        <section class="SectionParenthesis-articles hide-scrollbar">
            <p v-if="loading">Cargando publicaciones...</p>
            <p v-if="errorMessage">{{ errorMessage }}</p>

            <ParenthesisPost 
                v-for="post in posts" 
                :key="post.id"
                :post-obj="post"
            />
        </section>   
    </main>
</template>

<script>
import HeaderBand from '@/components/HeaderBand.vue';
import ParenthesisPost from '@/components/ParenthesisPost.vue';

export default {
    name: 'SectionParenthesis',
    components: {
        HeaderBand,
        ParenthesisPost,
    },
    data(){
        return{
            filterBtn: 'lasts',
            posts: [],
            allPosts: [],
            loading: false,
            errorMessage: '',
        }
    },
    methods: {
        async getPosts() {
            this.loading = true;
            this.errorMessage = '';

            try {
                const response = await fetch(`${this.$ENDPOINT}/api/get_posts.php`);
                const result = await response.json();

                if (result.status === 'success') {
                    this.posts = result.posts;
                    this.allPosts = result.posts;
                } else {
                    this.errorMessage = result.message || 'No se pudieron cargar las publicaciones.';
                }

            } catch (error) {
                console.error(error);
                this.errorMessage = 'Error al conectar con el servidor.';
            } finally {
                this.loading = false;
            }
        },

        searchBarEvents(term){

            const selected = (term || '').toLowerCase().trim();
            if(selected === '' || selected === 'todos'){
                this.posts = [...this.allPosts];
                return;
            }
            this.posts = this.allPosts.filter(post => {
                let tags = post.tags ?? post.tag ?? [];
                if(typeof tags === 'string') {
                    try {
                        tags = JSON.parse(tags);
                    } catch {
                        tags = [tags];
                    }
                }
                if(!Array.isArray(tags)) {
                    tags = [tags];
                }
                tags = tags.map(tag => String(tag).toLowerCase().trim());
                return tags.includes(selected);
            });
        }
    },
    mounted() {
        this.getPosts();
    }
}
</script>

<style scoped lang="stylus">
.SectionParenthesis-MAIN
    max-height: 100dvh !important
    overflow: hidden
    min-height: 0

.SectionParenthesis-articles
    flex: 1 1 auto
    min-height: 0
    overflow-y: auto
    margin-top: -3vw
    padding-top: 5vw
    padding-bottom: calc(6vw + 47px)
    mask-image: linear-gradient(to bottom,          transparent 3%, white 3%,       white 90%, transparent 100%)
    -webkit-mask-image: linear-gradient(to bottom,  transparent 3%, white 3%,       white 90%, transparent 100%)
</style>